export const ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    DEMO: 'demo'
  };